import renderAutoSuggestWithOptions from 'app/employer/components/autoSuggest/AutoSuggestHOC';
import { accountAutoCompleteInput$, accountAutoCompleteObservable$ } from 'app/employer/redux/autosuggest/autoCompleteService';

const AccountAutoSuggest = renderAutoSuggestWithOptions(
   accountAutoCompleteObservable$,
   accountAutoCompleteInput$,
);

AccountAutoSuggest.defaultProps = {
   selected: {
      id: null,
      label: '',
      description: '',
      userId: null,
   },
   forceSelection: false,
   placeholder: 'Search Account...',
};

export default AccountAutoSuggest;
